import { Box, Stack } from '@mui/material';
import { OrderDeliveryDetail } from '../OrderDeliveryDetail/OrderDeliveryDetail';
import { ProductList } from './ProductList/ProductList';

export function ProductAndConfigurations() {
  return (
    <Box sx={{ width: '100%' }}>
      <Stack sx={{ flexGrow: 1 }} spacing="16px">
        <ProductList />
      </Stack>
      <OrderDeliveryDetail />
    </Box>
  );
}
